import ProjectForm from '../ProjectForm';
import SettingsModal from '../SettingsModal';
import ICalExportModal from '../ICalExportModal';
import HolidayModal from '../HolidayModal';
import CalendarManagerModal from '../CalendarManagerModal';
import ICalSettingsModal from '../ICalSettingsModal';
import SharingPanel from '../SharingPanel';

/**
 * Component that renders all modals used in the Calendar.
 * Pure presentational component - all state and handlers are passed as props.
 */
function CalendarModals({
  // Project form
  showProjectForm,
  editingProject,
  projects,
  onSaveProject,
  onCancelProject,
  onDeleteProject,
  // Settings modal
  showSettingsModal,
  onCloseSettings,
  onManageHolidays,
  onExportJSON,
  onExportICS,
  onImport,
  // iCal export modal
  showICalExportModal,
  onCloseICalExport,
  onICalExportConfirm,
  // Holiday modal
  showHolidayModal,
  holidays,
  onAddHoliday,
  onUpdateHoliday,
  onDeleteHoliday,
  onCloseHolidayModal,
  // Calendar manager modal
  showCalendarManager,
  onCloseCalendarManager,
  // iCal settings modal
  showICalSettings,
  onCloseICalSettings,
  onOpenICalSettings,
  // Sharing panel
  showSharingPanel,
  onCloseSharingPanel
}) {
  return (
    <>
      {/* Project form modal */}
      {showProjectForm && (
        <ProjectForm
          project={editingProject}
          otherProjects={editingProject ? projects.filter(p => p.id !== editingProject.id) : []}
          onConfirm={onSaveProject}
          onCancel={onCancelProject}
          onDelete={onDeleteProject}
          canDelete={projects.length > 1}
        />
      )}

      {/* Settings modal */}
      {showSettingsModal && (
        <SettingsModal
          onClose={onCloseSettings}
          onManageHolidays={onManageHolidays}
          onExportJSON={onExportJSON}
          onExportICS={onExportICS}
          onImport={onImport}
          onICalSettings={onOpenICalSettings}
        />
      )}

      {/* iCalendar export modal */}
      {showICalExportModal && (
        <ICalExportModal
          key="ical-export"
          isOpen={showICalExportModal}
          onClose={onCloseICalExport}
          onExport={onICalExportConfirm}
        />
      )}

      {/* Holiday management modal */}
      {showHolidayModal && (
        <HolidayModal
          holidays={holidays}
          onAddHoliday={onAddHoliday}
          onUpdateHoliday={onUpdateHoliday}
          onDeleteHoliday={onDeleteHoliday}
          onClose={onCloseHolidayModal}
        />
      )}

      {/* Calendar manager modal */}
      <CalendarManagerModal
        isOpen={showCalendarManager}
        onClose={onCloseCalendarManager}
      />

      {/* iCal settings modal */}
      <ICalSettingsModal
        isOpen={showICalSettings}
        onClose={onCloseICalSettings}
      />

      {/* Sharing panel */}
      <SharingPanel
        isOpen={showSharingPanel}
        onClose={onCloseSharingPanel}
      />
    </>
  );
}

export default CalendarModals;
